import { NonterminalKind } from '@nomicfoundation/slang/cst';
import { line } from '../slang-printers/prettier-builders.js';
import { printSeparatedItem } from '../slang-printers/print-separated-item.js';
import { extractVariant } from '../slang-utils/extract-variant.js';
import { SlangNode } from './SlangNode.js';
import { Expression } from './Expression.js';
import { ReturnsDeclaration } from './ReturnsDeclaration.js';
import { Block } from './Block.js';
import { CatchClauses } from './CatchClauses.js';

import type * as ast from '@nomicfoundation/slang/ast';
import type { Doc } from 'prettier';
import type { CollectedMetadata, PrintFunction } from '../types.d.ts';

export class TryStatement extends SlangNode {
  readonly kind = NonterminalKind.TryStatement;

  expression: Expression['variant'];

  returns?: ReturnsDeclaration;

  body: Block;

  catchClauses: CatchClauses;

  constructor(ast: ast.TryStatement, collected: CollectedMetadata) {
    super(ast, collected);

    this.expression = extractVariant(new Expression(ast.expression, collected));
    if (ast.returns) {
      this.returns = new ReturnsDeclaration(ast.returns, collected);
    }
    this.body = new Block(ast.body, collected);
    this.catchClauses = new CatchClauses(ast.catchClauses, collected);

    this.updateMetadata(
      this.expression,
      this.returns,
      this.body,
      this.catchClauses
    );
  }

  print(print: PrintFunction): Doc {
    const returnsDoc = print('returns');
    return [
      'try',
      printSeparatedItem(print('expression'), {
        firstSeparator: line
      }),
      [
        returnsDoc ? [returnsDoc, ' '] : returnsDoc,
        print('body'),
        ' ',
        print('catchClauses')
      ]
    ];
  }
}
